import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-social-feed',
  templateUrl: './social-feed.component.html',
  styleUrls: ['./social-feed.component.scss']
})
export class SocialFeedComponent implements OnInit, AfterViewInit {

  @ViewChild('iframe', { static: false }) iframe: ElementRef;
  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow.document;
      const head = doc.head || doc.getElementsByTagName('head')[0];

      const style = doc.createElement('style');

      const css = ".referral{display:none}";

      style.innerHTML = css;

      head.appendChild(style);
  }

}
